import { useQuery } from '@tanstack/react-query';
import { getDownloadTemplateSales } from 'services/api/requests/uploads/uploads';

export const useDownloadTemplateSale = () => {
	return useQuery(['download-template-sales'], getDownloadTemplateSales, {
		refetchOnWindowFocus: false,
		enabled: false,
	});
};
